import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Button, Card, CardHeader, Col, Row} from "reactstrap";
const {Form, FormActions, FormBody} = form;
import {reduxForm} from "redux-form";
import {redirectToOrderStep} from "../utils/utils";
import KontaktniUdajePanel from "../components/KontaktniUdajePanel";
import ZpusobDodaniPanel from "../components/ZpusobDodaniPanel";
import * as steps from "../const/routes";
import NahraneSouboryPanel from "../components/NahraneSouboryPanel";
import ZpusobPlatbyPanel from "../components/ZpusobPlatbyPanel";
import './PotvrzeniForm.scss';
import ParametryObjednavkyPanel from "../components/ParametryObjednavkyPanel";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář procesu objednávky - Potvrzení objednávky.
 * Ve skutečnosti neobsahuje žádné fieldy, formulářový je jenom submit button.
 */
class PotvrzeniForm extends Component<WithTranslation> {

    static formName = 'PotvrzeniForm';

    static propTypes = {
        nahraneSouboryList: PropTypes.array.isRequired, // seznam nahraných souborů
        zakazkaData: PropTypes.object.isRequired, // data z kroku Zákázka
        zakaznikData: PropTypes.object.isRequired, // data z kroku Zákazník
        dopravaData: PropTypes.object.isRequired, // data z kroku Doprava
        platbaData: PropTypes.object.isRequired, // data z kroku Platba
        zpusobPlatba: PropTypes.object.isRequired, // VO zvoleného způsobu platby
        pobocka: PropTypes.object, // VO pobočky, pokud je objednávka na pobočku
        adresa: PropTypes.object, // VO adresy, pokud je objednávka na adresu
        terminDoprava: PropTypes.object, // VO termínu dopravy, pokud je objednávka na adresu
    };

    render() {
        const {
            onClose, handleSubmit, submitting, nahraneSouboryList, pobocka, adresa, zakazkaData, zpusobPlatba, zakaznikData,
            dopravaData, platbaData, terminDoprava, t
        } = this.props;

        return <Form onSubmit={handleSubmit} horizontal className="potvrzeni-form">
            <FormBody>
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardHeader>
                                <h2>{t('order.summary')}</h2>
                            </CardHeader>
                            <div className="potvrzeni-wrapper">
                                <Row className="potvrzeni-row">
                                    <Col xs={4}>
                                        <NahraneSouboryPanel soubory={nahraneSouboryList.map(soubor => soubor.podslozky + soubor.name)} />
                                    </Col>
                                    <Col xs={4}>
                                        <KontaktniUdajePanel kontaktniUdaje={zakaznikData} />
                                    </Col>
                                </Row>
                                <Row className="potvrzeni-row">
                                    <Col xs={4}>
                                        <ZpusobDodaniPanel
                                            adresa={adresa}
                                            pobocka={pobocka}
                                            datum={pobocka ? dopravaData.datumVyzvednuti : dopravaData.datumDoruceni}
                                            casVyzvednuti={dopravaData.casVyzvednuti}
                                            terminDoprava={terminDoprava}
                                        />
                                    </Col>
                                    <Col xs={4}>
                                        <ZpusobPlatbyPanel zpusobPlatba={zpusobPlatba} cenovaNabidka={platbaData.cenovaNabidka} />
                                    </Col>
                                </Row>
                                <Row className="potvrzeni-row">
                                    <Col xs={10}>
                                        <ParametryObjednavkyPanel objednavka={zakazkaData} zakaznikData={zakaznikData} readOnly={true} withoutRights />
                                    </Col>
                                </Row>
                            </div>
                        </Card>
                    </Col>
                    <Col xs={12} className="submit-button-panel">
                        <Button color="secondary" type="button" onClick={redirectToOrderStep.bind(this, steps.PLATBA, this.props)}>{t('buttons.back')}</Button>
                        <Button color="primary">{t('order.submit_order')}</Button>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} disabled={submitting} />
        </Form>
    }
}

export default withTranslation()(withRouter(connect()(reduxForm({
    form: PotvrzeniForm.formName,
})(PotvrzeniForm))));
